__turbopack_context__.v({
  "name": "_4IrDmq_name",
  "nameLine": "_4IrDmq_nameLine",
  "nameTagSuffix": "_4IrDmq_nameTagSuffix",
  "row": "_4IrDmq_row" + " " + __turbopack_context__.i(917291)["lbRadialStroke"] + " " + __turbopack_context__.i(917291)["lbStrokeCard"] + " " + __turbopack_context__.i(917291)["lbCardBlur"] + " " + __turbopack_context__.i(917291)["lbCardBg"],
  "score": "_4IrDmq_score" + " " + __turbopack_context__.i(917291)["geistMonoNumbers"],
  "tagSeparator": "_4IrDmq_tagSeparator",
});
